import { render } from "./PasswordForm.vue?vue&type=template&id=7c425bef"
import script from "./PasswordForm.vue?vue&type=script&lang=js"
export * from "./PasswordForm.vue?vue&type=script&lang=js"

import exportComponent from "/home/jannie/Projects/alice-stone/alice-stone-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__